import { render, staticRenderFns } from "./DashboardAreaPopup.vue?vue&type=template&id=3f61b45c"
import script from "./DashboardAreaPopup.vue?vue&type=script&lang=js"
export * from "./DashboardAreaPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports